(() => {
  const viewport = matchMedia('(max-width: 749px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let teardown = () => {};

  function mount() {
    teardown();
    if (!viewport.matches) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const cleanups = [];
    const observers = [];
    const listen = (element, name, callback, options = {}) => element?.addEventListener(name, callback, {...options, signal});
    const template = name => document.querySelector(`[data-ix-mobile-${name}-template]`)?.content.firstElementChild.cloneNode(true);
    const behavior = () => reduced.matches ? 'instant' : 'smooth';
    const visible = element => Boolean(element && !element.closest('[hidden]') && element.getClientRects().length);

    document.querySelectorAll('.ix-card--cherry-blossom-sweatpants a[href]').forEach(link => {
      const original = link.getAttribute('href');
      const url = new URL(link.href);
      url.searchParams.set('fit', 'Fleece');
      link.href = url.pathname + url.search;
      cleanups.push(() => link.setAttribute('href', original));
    });

    let lightbox;
    let activeGallery;
    let returnFocus;
    let suppressClickUntil = 0;
    const buttons = gallery => [...gallery.querySelectorAll('[data-ix-view]')].filter(button => !button.hidden);
    const activePanel = gallery => gallery.querySelector('[data-ix-panel].is-active:not([hidden])');

    function renderLightbox() {
      const panel = activePanel(activeGallery);
      if (!panel || !lightbox) return;
      const clone = panel.cloneNode(true);
      clone.removeAttribute('id');
      clone.removeAttribute('hidden');
      clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      clone.querySelectorAll('img').forEach(image => {
        image.loading = 'eager';
        image.sizes = '100vw';
      });
      lightbox.querySelector('.ix-mobile-lightbox-media').replaceChildren(clone);
      lightbox.querySelector('.ix-mobile-lightbox-copy').textContent = [panel.querySelector('figcaption')?.textContent.trim(), panel.dataset.ixModel].filter(Boolean).join('. ');
      const views = buttons(activeGallery);
      const selected = views.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      lightbox.querySelector('[data-ix-mobile-count]').textContent = `${selected + 1} / ${views.length}`;
    }

    function advance(gallery, direction) {
      const views = buttons(gallery);
      const selected = views.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      const next = views[(selected + direction + views.length) % views.length];
      next?.click();
      if (next) {
        const controls = next.parentElement;
        controls.scrollTo({left: next.offsetLeft - controls.offsetLeft - (controls.clientWidth - next.offsetWidth) / 2, behavior: behavior()});
      }
    }

    function openLightbox(gallery, trigger) {
      if (!visible(gallery)) return;
      if (!lightbox) {
        lightbox = template('lightbox');
        if (!lightbox) return;
        document.body.append(lightbox);
        listen(lightbox.querySelector('[data-ix-mobile-close]'), 'click', () => lightbox.close());
        listen(lightbox.querySelector('[data-ix-mobile-previous]'), 'click', () => advance(activeGallery, -1));
        listen(lightbox.querySelector('[data-ix-mobile-next]'), 'click', () => advance(activeGallery, 1));
        listen(lightbox, 'keydown', event => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          advance(activeGallery, event.key === 'ArrowRight' ? 1 : -1);
        });
        listen(lightbox, 'close', () => returnFocus?.isConnected && returnFocus.focus({preventScroll: true}));
      }
      activeGallery = gallery;
      returnFocus = trigger;
      renderLightbox();
      if (!lightbox.open) lightbox.showModal();
    }

    document.querySelectorAll('[data-ix-gallery]').forEach(gallery => {
      const stage = gallery.querySelector('.ix-gallery-stage');
      if (!stage || !gallery.querySelector('[data-ix-view]')) return;
      const hint = template('gallery');
      if (!hint) return;
      const enlarge = hint.querySelector('button');
      stage.append(enlarge);
      stage.after(hint);
      cleanups.push(() => { hint.remove(); enlarge.remove(); });
      listen(enlarge, 'click', event => openLightbox(gallery, event.currentTarget));
      listen(stage, 'click', event => {
        if (!event.target.closest('button') && performance.now() > suppressClickUntil) openLightbox(gallery, enlarge);
      });
      let start;
      listen(stage, 'touchstart', event => {
        start = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : undefined;
      }, {passive: true});
      listen(stage, 'touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        start = undefined;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        suppressClickUntil = performance.now() + 500;
        advance(gallery, dx < 0 ? 1 : -1);
      }, {passive: true});
      listen(stage, 'touchcancel', () => start = undefined, {passive: true});
      listen(gallery, 'ix:gallery-change', () => {
        if (lightbox?.open && activeGallery === gallery) renderLightbox();
      });
    });

    const chartTemplate = document.querySelector('[data-ix-mobile-charts-template]');
    chartTemplate?.content.querySelectorAll('[data-ix-mobile-chart]').forEach(source => {
      const copy = document.querySelector(`[data-ix-guide-copy="${source.dataset.ixMobileChart}"]`);
      if (!copy || copy.querySelector('img')) return;
      const chart = source.cloneNode(true);
      copy.append(chart);
      listen(chart, 'click', event => {
        const unit = event.target.closest('[data-ix-mobile-unit]')?.dataset.ixMobileUnit;
        if (!unit) return;
        chart.querySelectorAll('[data-ix-mobile-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ixMobileUnit === unit)));
        chart.querySelectorAll('[data-ix-mobile-table]').forEach(table => table.hidden = table.dataset.ixMobileTable !== unit);
      });
      cleanups.push(() => chart.remove());
    });

    document.querySelectorAll('.ix-shop-form').forEach(form => {
      const section = form.closest('.shopify-section');
      const info = form.closest('.ix-product-info');
      const media = section?.querySelector('.product-information__media');
      const titleNode = info?.querySelector('h1');
      const priceNode = info?.querySelector('.ix-bundle-price');
      if (titleNode && priceNode && media) {
        const titleAnchor = document.createTextNode('');
        const priceAnchor = document.createTextNode('');
        titleNode.before(titleAnchor);
        priceNode.before(priceAnchor);
        const wrapper = document.createElement('div');
        wrapper.className = 'ix-mobile-product-heading';
        media.before(wrapper);
        wrapper.append(titleNode, priceNode);
        cleanups.push(() => { titleAnchor.before(titleNode); priceAnchor.before(priceNode); titleAnchor.remove(); priceAnchor.remove(); wrapper.remove(); });
      }
      const originalButton = form.querySelector('.ix-bundle-submit');
      const price = section?.querySelector('[data-ix-price]');
      const bar = template('purchase');
      if (!originalButton || !bar || !price) return;
      const title = section.querySelector('h1')?.textContent.trim() || '';
      bar.querySelector('[data-ix-mobile-title]').textContent = title;
      document.body.append(bar);
      document.body.classList.add('ix-mobile-shopping');
      const button = bar.querySelector('[data-ix-mobile-buy]');
      let originalVisible = false;
      const sync = () => {
        const label = originalButton.textContent.trim();
        button.textContent = label;
        button.disabled = originalButton.disabled && label !== 'Choose your size';
        bar.querySelector('[data-ix-mobile-price]').textContent = price.textContent.trim();
        bar.hidden = originalVisible;
      };
      const observer = new MutationObserver(sync);
      [originalButton, price].forEach(element => observer.observe(element, {attributes: true, childList: true, subtree: true, characterData: true}));
      observers.push(observer);
      const intersection = new IntersectionObserver(entries => {
        originalVisible = entries[0].intersectionRatio >= .9;
        sync();
      }, {threshold: [0,.9,1], rootMargin: '0px 0px -90px 0px'});
      intersection.observe(originalButton);
      observers.push(intersection);
      listen(button, 'click', () => {
        if (!originalButton.disabled) {
          form.requestSubmit(originalButton);
          return;
        }
        const fields = [...form.querySelectorAll('fieldset')].filter(visible);
        const missing = fields.find(field => field.querySelector('input[type="radio"]') && !field.querySelector('input:checked'));
        const target = missing || [...form.querySelectorAll('select')].find(select => visible(select) && !select.value) || form;
        const header = document.getElementById('header-component')?.getBoundingClientRect().height || 64;
        const top = target.getBoundingClientRect().top + window.scrollY - header - 14;
        window.scrollTo({top, behavior: behavior()});
        const focus = target.matches('select') ? target : target.querySelector('input:not(:disabled),select:not(:disabled)');
        focus?.focus({preventScroll: true});
      });
      sync();
      cleanups.push(() => bar.remove());
    });

    teardown = () => {
      controller.abort();
      observers.forEach(observer => observer.disconnect());
      if (lightbox?.open) lightbox.close();
      lightbox?.remove();
      cleanups.reverse().forEach(cleanup => cleanup());
      document.body.classList.remove('ix-mobile-shopping');
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true});
  else mount();
  viewport.addEventListener('change', mount);
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', () => teardown());
})();
